import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IbexImageComponent } from './ibex-image/ibex-image.component';
import { ClockComponent } from './clock/clock.component';
import { KeyboardComponent } from './keyboard/keyboard.component';
import { FormsModule } from '@angular/forms';
import { IbexIconModule } from '@ibexfusion/ibex-icon';
import { PipesModule } from '../pipes/pipes.module';
import { QrCodeComponent } from './qr-code/qr-code.component';
import { MessagePopupComponent } from './popups/message-popup/message-popup.component';
import { LoaderComponent } from './loader/loader.component';
import { MarketDetailComponent } from './market-detail/market-detail.component';
import { Keyboard2Component } from './keyboard-2/keyboard-2.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IbexIconModule,
    PipesModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    IbexImageComponent,
    ClockComponent,
    KeyboardComponent,
    Keyboard2Component,
    QrCodeComponent,
    MessagePopupComponent,
    LoaderComponent,
    MarketDetailComponent
  ],
  exports: [
    IbexImageComponent,
    ClockComponent,
    KeyboardComponent,
    Keyboard2Component,
    QrCodeComponent,
    LoaderComponent,
    MarketDetailComponent
  ]
})
export class GlobalComponentsModule {
}
